if (!customElements.get('collection-toolbar')) {
  class CollectionToolbar extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-collection-filter-open]').forEach((button) => {
        button.addEventListener('click', () => {
          document.querySelector('.mobile-facets__wrapper summary')?.click();
        });
      });

      this.querySelectorAll('[data-sort-value]').forEach((button) => {
        button.addEventListener('click', () => this.handleSortSelect(button));
      });

      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      document.addEventListener('click', this.handleOutsideClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleOutsideClick);
    }

    handleSortSelect(button) {
      const select = document.querySelector('#FacetSortDrawerForm select[name="sort_by"]');
      if (!select) return;

      select.value = button.dataset.sortValue;
      select.dispatchEvent(new Event('input', { bubbles: true }));

      this.querySelectorAll('.collection-toolbar__sort-option').forEach((option) => {
        const isSelected = option.dataset.sortValue === button.dataset.sortValue;
        option.classList.toggle('is-selected', isSelected);
        option.toggleAttribute('aria-selected', isSelected);
      });

      this.querySelectorAll('.collection-toolbar__sort-container[open]').forEach((container) => {
        container.removeAttribute('open');
      });
    }

    handleOutsideClick(event) {
      this.querySelectorAll('.collection-toolbar__sort-container[open]').forEach((container) => {
        if (!container.contains(event.target)) {
          container.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('collection-toolbar', CollectionToolbar);
}
